var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"branch"},[_c('div',{staticClass:"value"},[_vm._v(_vm._s(_vm.location.number))]),_c('div',{staticClass:"value secondary-text"},[_vm._v(_vm._s(_vm.location.city))]),_c('div',{staticClass:"value secondary-text"},[_vm._v(_vm._s(_vm.location.address))])])
}
var staticRenderFns = []

export { render, staticRenderFns }